<template>
  <app-form-select
    :datas="industries"
    :labelText="labelText ?? $t('general.industries')"
    :errorMessage="errorMessage"
    :serverMessage="serverMessage"
    :loading="loading"
    :showLabel="showLabel"
    :allowFilter="allowFilter"
    v-model="checkedValue"
    v-on:retry="getIndustries"
    v-on:valueSelected="onValueSelected"
  />
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    allowFilter: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      default: () => {},
    },
    country_id: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    country_id: function (newVal, oldValue) {
      this.getIndustries(newVal);
    },
    industries(industries) {
      if (this.$lodash.isEmpty(industries)) {
        this.onValueSelected(null);
      }
    },
  },
  computed: {
    checkedValue: {
      get() {
        if (this.$lodash.isEmpty(this.industries)) {
          return {};
        }
        return this.modelValue ?? [];
      },
      set(value) {
        this.onValueSelected(value);
      },
    },

    industries() {
      return this.$store.getters["referenceStore/industries"];
    },

    loading() {
      return this.$store.getters["referenceStore/loading"];
    },

    serverMessage() {
      return this.$store.getters["referenceStore/message"] ?? "";
    },
  },

  async mounted() {
    this.getIndustries();
  },

  methods: {
    async getIndustries() {
      this.$store.commit("referenceStore/resetState");
      this.$store.dispatch("referenceStore/getIndustries", this.country_id);
    },

    onValueSelected(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>


